import L from "leaflet";

export const offsetPosition = (map, geometry, x, y) => {
  const point = map.latLngToContainerPoint(geometry);
  const newPoint = L.point([point.x + x, point.y + -y]);
  return map.containerPointToLatLng(newPoint);
};
